import { createAction } from '@reduxjs/toolkit';
import { setProPayloadT } from 'Store/Actions/ts/index';
// import { setProPayloadT } from './ts';
export const setProp = createAction<setProPayloadT>('setProp');
export const dot_addCartItem = createAction('cartBoq/dot_addCartItem');
export const dot_updateCartItem = createAction('cartBoq/dot_updateCartItem');
export const dot_removeCartItem = createAction('cartBoq/dot_removeCartItem');
